import { useMemo } from 'react';

import type { SupporterComment } from '../../../../../../shared/types';

const DESCRIPTION_LENGTH_THRESHOLD = 350;

export function useIsCommentTooLong(supporterComment: SupporterComment) {
	const isCommentTooLong = useMemo(
		() => supporterComment.comment.length > DESCRIPTION_LENGTH_THRESHOLD,
		[supporterComment],
	);

	const content = useMemo(() => {
		if (!isCommentTooLong || supporterComment.comment.length <= DESCRIPTION_LENGTH_THRESHOLD)
			return supporterComment.comment;
		return `${supporterComment.comment.substring(0, DESCRIPTION_LENGTH_THRESHOLD)}...`;
	}, [supporterComment, isCommentTooLong]);

	return { isCommentTooLong, content };
}
